import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2CustomerDecline = hashCodeCertificate("WaybillV2CustomerDecline")

export default WaybillV2CustomerDecline
